export var docElement = document.documentElement;


//////////////////
// WEBPACK FOOTER
// /Users/maciejwarych/Local Sites/vidoq/app/public/wp-content/themes/vidoq/node_modules/tiny-slider/src/helpers/docElement.js
// module id = 7
// module chunks = 0